import { render, staticRenderFns } from "./info-clinique.html?vue&type=template&id=ba8f0730&scoped=true&external"
import script from "./info-clinique.js?vue&type=script&lang=js&external"
export * from "./info-clinique.js?vue&type=script&lang=js&external"
import style0 from "./info-clinique.scss?vue&type=style&index=0&id=ba8f0730&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f0730",
  null
  
)

export default component.exports